import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { StudyModel } from 'src/app/_models/study.model';
import { OpenAiModel } from 'src/app/_models';


@Injectable({
  providedIn: 'root'
})
export class OpenAiService {
  private apiPATH = "OpenAI/";

  constructor(
    private _api: ApiService,
  ) { }

  getAIReport(request: OpenAiModel) {
    return this._api.post<any>(`${this.apiPATH}getAIReport`, request);
  }

  dicomToImageExtract(orderId: number, accessionNo: string) {
    return this._api.post<StudyModel>(`${this.apiPATH}dicomToImageExtract/${orderId}/${accessionNo}`, {});
  }
}
